export const amountFormat = (amount=0) => {
    try{
    if(amount){
        if(isNaN(amount) && amount ===0) return amount;
        return parseFloat(amount).toFixed(2);
    }else{
        return amount 
    }
}catch(e){}
}